import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import format from 'date-fns/format';
import { SuccessComponent } from '../success/success.component';
import { ModalService } from 'src/app/services/modal.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { createSeason } from 'src/app/store/actions/tournament.action';
import { stat } from 'fs';
@Component({
  selector: 'app-create-season',
  templateUrl: './create-season.component.html',
  styleUrls: ['./create-season.component.scss']
})
export class CreateSeasonComponent implements OnInit {

  form: FormGroup

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      season: ['', Validators.required],
      seasonStart: ['', Validators.required],
      seasonEnd: ['', Validators.required],
      status: ['', Validators.required],
    })
  }

  createSeason(){
    const startValue = this.seasonStart?.value;
    const endValue = this.seasonEnd?.value;
    
    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    // if(isBefore(endDate, startDate)){
    //   console.error("Invalid End Date: Must be after or equal to Start Date");
    //   return;
    // }

    const payload = {
      season: this.season?.value,
      seasonStart: format(startDate, 'yyyy-MM-dd'),
      seasonEnd: format(endDate, 'yyyy-MM-dd'),
      status: this.status?.value
    };

    this.modalService.showLoadingSpinner();
    this.store.dispatch(createSeason({data: payload}));
  }

  get season(){
    return this.form.get('season');
  }

  get seasonStart(){
    return this.form.get('seasonStart');
  }

  get seasonEnd(){
    return this.form.get('seasonEnd');
  }
  
  get status(){
    return this.form.get('status');
  }

  close(){
    this.modalService.hideCreateSeason(); 
  }

  dateToday = new Date(); 

  openModalSuccess(){
    // const modalRef = this.modalService.open(SuccessComponent, { centered: true });
    // modalRef.componentInstance.headerText = 'Season Created Successfully';
    // modalRef.componentInstance.subText = 'The new season has been successfully created. Would you like to proceed on creating league?';
  }
}
